/**
 * External dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';

/**
 * Internal dependencies
 */
import {
	PREFERENCES_SET,
	PREFERENCES_RECEIVE,
	PREFERENCES_FETCH,
	PREFERENCES_FETCH_SUCCESS,
	PREFERENCES_FETCH_FAILURE,
	PREFERENCES_SAVE
} from 'state/action-types';

export const receivePreferences = (values) => {
	return {
		type: PREFERENCES_RECEIVE,
		values,
	};
};

export const fetchPreferences = () => {
	return (dispatch) => {
		dispatch({
			type: PREFERENCES_FETCH,
		});

        return cecSdk
			.preferences()
			.getPreferences()
			.then((preferences) => {
				dispatch({ type: PREFERENCES_FETCH_SUCCESS, values: preferences });
				dispatch({ type: PREFERENCES_RECEIVE, values: preferences });
                return preferences;
			})
			.catch((error) =>
				dispatch({
					type: PREFERENCES_FETCH_FAILURE,
					error,
				}),
			);
	};
};

export const setPreference = (key, value) => ({
	type: PREFERENCES_SET,
	key,
	value,
});

export const savePreference = (key, value) => async (dispatch, getState) => {
	dispatch(setPreference(key, value));
	dispatch({
		type: PREFERENCES_SAVE,
		key,
		value,
	});
	
	const payload = {
		[key]: value,
	};

    return await cecSdk
		.preferences()
		.savePreferences(payload)
		.then((response) => {
			dispatch(receivePreferences(response));
		});
};
